import React from 'react'

import * as styles from './form.module.scss'

export const ErrorMessage: React.FC = () => {
  return (
    <div className={styles.errorwarn}>
      <h2>Something went wrong</h2>
      <img src="/media/error-warn-icon.svg" alt="error" />
      <p>
        We aren’t able to process your request.
        <br /> Please try again later.
      </p>
    </div>
  )
}
